import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'
import { Form } from 'react-final-form'
import { Row, Col, Button, Spin, message } from 'antd'
import { Field } from 'react-final-form'
import TextInput from 'components/TextInput'
import useAction from 'utils/useAction'
import { required, validUserEmail } from 'helpers/validators'
import { selectors as arcAdvertisersSelectors } from 'domains/arcAdvertisers'
import * as actions from 'actions/views/arcAdvertisers'
import { formatArcAdvertiserForApi, formatArcAdvertiserForForm } from 'domains/arcAdvertisers/formatters'
import { StyledForm, ButtonContainer } from './AdvertiserForm.styles'

const AdvertiserForm = ({ advertiserId, onSuccess, onCancel }) => {
  const isSaving = useSelector(arcAdvertisersSelectors.getIsSavingActive)
  const selectedAdvertiser = useSelector(arcAdvertisersSelectors.getSelectedAdvertiser)
  const getAdvertiserById = useSelector(arcAdvertisersSelectors.getArcAdvertiserById)
  const createAdvertiser = useAction(actions.createArcAdvertiser)
  const updateAdvertiser = useAction
    (actions.updateArcAdvertiser)
  const fetchAdvertiserDetails = useAction(actions.fetchArcAdvertiserDetails)
  const advertiser = advertiserId ? getAdvertiserById(advertiserId) || selectedAdvertiser : null
  const isEdit = !!advertiserId

  useEffect(() => {
    if (advertiserId && !advertiser) {
      fetchAdvertiserDetails({ id: advertiserId })
    }
  }, [advertiserId, advertiser, fetchAdvertiserDetails])

  const handleSubmit = async (values) => {
    try {
      const formattedData = formatArcAdvertiserForApi(values)
      if (isEdit) {
        formattedData.id = advertiserId
        updateAdvertiser({
          data: formattedData,
          callback: () => {
            message.success('Advertiser updated successfully!')
            onSuccess()
          }
        })
      } else {
        createAdvertiser({
          data: formattedData,
          callback: () => {
            message.success('Advertiser created successfully!')
            onSuccess()
          }
        })
      }
    } catch (error) {
      console.error('Error submitting advertiser form:', error)
      message.error('Failed to save advertiser. Please try again.')
    }
  }

  const initialValues = isEdit ? formatArcAdvertiserForForm(advertiser) : {}

  return (
    <Spin spinning={isSaving}>
      <Form
        onSubmit={handleSubmit}
        initialValues={initialValues}
        render={({ handleSubmit, pristine, hasValidationErrors, values }) => {
          return (
            <StyledForm onSubmit={handleSubmit}>
              <Row gutter={[16, 16]}>
                <Col span={24}>
                  <Field
                    required
                    name="name"
                    validate={required}
                    label="Name"
                    placeholder="Enter advertiser name"
                    component={TextInput}
                  />
                </Col>
              </Row>

              <ButtonContainer>
                <Button onClick={onCancel}>
                  Cancel
                </Button>
                <Button
                  type="primary"
                  htmlType="submit"
                  loading={isSaving}
                >
                  {isEdit ? 'Update Advertiser' : 'Create Advertiser'}
                </Button>
              </ButtonContainer>
            </StyledForm>
          )
        }}
      />
    </Spin>
  )
}

AdvertiserForm.propTypes = {
  advertiserId: PropTypes.string,
  onSuccess: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
}

export default AdvertiserForm